import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BooleanPipe } from './boolean.pipe';
import { DataPipe } from './data.pipe';
import { MoedaPipe } from './moeda.pipe';
import { OpcoesPipe } from './opcoes.pipe';
import { FilterListPipe } from './filter-list.pipe';

@NgModule({
  declarations: [
    BooleanPipe, 
    DataPipe, 
    MoedaPipe,
    OpcoesPipe,
    FilterListPipe
  ],
  imports: [
    CommonModule
  ],
  exports:[
    BooleanPipe, 
    DataPipe, 
    MoedaPipe,
    OpcoesPipe,
    FilterListPipe
  ],
  
})
export class PipesModule { }
